import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  CourseGroupInput,
  useUpdateSkillAssociationMutation,
} from 'features/classCreation';
import Form from 'components/Form';
import FieldErrors from 'components/FieldErrors';

function EditTaSkillForm({ academyTopic, isEditing, setIsEditing }) {
  const [course, setCourse] = useState(academyTopic.course_group);
  const [
    updateAcademyTopic,
    { isSuccess, error, isLoading: isUpdating, reset },
  ] = useUpdateSkillAssociationMutation();

  useEffect(() => {
    if (!isEditing) {
      setCourse(academyTopic.course_group);
      if (error) {
        reset();
      }
    }
  }, [academyTopic.course_group, error, isEditing, reset]);

  const handleAcademyTopicChange = useCallback((newTopic) => {
    setCourse(newTopic);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('TA Skill is updated successfully!');
      setIsEditing(false);
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in updating the TA skill. Please try again later!'
      );
    }
  }, [error, isSuccess, setIsEditing]);

  const handleAcademyTopicUpdate = useCallback(
    (e) => {
      e.preventDefault();
      updateAcademyTopic({
        academyTopicId: academyTopic.id,
        courseGroup: course,
      });
    },
    [academyTopic.id, course, updateAcademyTopic]
  );

  return (
    <Form onSubmit={handleAcademyTopicUpdate}>
      <CourseGroupInput
        value={course}
        disabled={!isEditing}
        onChange={handleAcademyTopicChange}
      />
      <FieldErrors
        name="course_group"
        errors={error?.data?.errors}
      />
      {isEditing && (
        <Tappable
          type="submit"
          disabled={isUpdating}
          className="btn btn-primary btn-long m-t-xs"
          onClick={handleAcademyTopicUpdate}
        >
          Update TA Skill
        </Tappable>
      )}
    </Form>
  );
}

export default EditTaSkillForm;
